import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

export interface IconDescriptor {
  iconUrl: string;
  name: string;
  diameter?: number;
}

@Component({
  imports: [NgStyle],
  selector: 'va-icon',
  template: `
    <div
      class="va-icon-container"
      [style.background-color]="iconUrl ? '' : getIconColorForName()"
      [style.border-style]="borderColor ? 'solid' : ''"
      [style.border-color]="borderColor ? borderColor : ''"
      [ngStyle]="getIconSize()"
      >
      @if (iconUrl) {
        <img
          class="icon-size"
          [src]="iconUrl"
        onError="this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNs+A8AAgUBgQvw1B0AAAAASUVORK5CYII='"
      />
}
      @if (iconName && !iconUrl) {
<span [style.color]="fontColor">
        {{ getAbbreviationForName() }}
      </span>
}
      @if (!iconUrl && !iconName) {
<div class="stencil-icon shimmer"></div>
}
    </div>
  `,
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input() iconUrl: string;
  @Input() iconName: string; // it seems like the angular template is not recognizing the variable 'name'
  @Input() diameter = 60;
  @Input() backgroundColor = null;
  @Input() borderColor = null;
  @Input() fontColor = 'white';

  public getAbbreviationForName(): string {
    const defaultAbbreviation = 'U'; // untitled
    if (this.iconName) {
      // example input "Partner Central"
      // example output "PC"

      // example input "Partner"
      // example output "P"
      const names = this.iconName.trim().split(' ')?.filter(Boolean);
      return names.length > 1 ? names[0][0] + names[1][0] : names[0][0];
    }
    return defaultAbbreviation;
  }

  getIconColorForName(): string {
    // determine an icon color for a product with no icon by using the product name
    const COLOR_CODES = [
      '#EF5350',
      '#42A5F5',
      '#66BB6A',
      '#FFA726',
      '#AB47BC',
      '#FFCA28',
      '#EC407A',
      '#26C6DA',
      '#FF7B57',
    ];
    let nameSum = 0;
    const defaultColor = '#808080';
    if (this.backgroundColor) {
      return this.backgroundColor;
    }
    if (!this.iconName) {
      return defaultColor;
    }
    for (let i = 0; i < this.iconName.length; i++) {
      nameSum += this.iconName[i].charCodeAt(0);
    }
    const index = nameSum % COLOR_CODES.length;

    return COLOR_CODES[index];
  }

  getIconSize(): any {
    return { 'font-size': this.diameter + 'px' };
  }
}
